import API from "@/services/api";
import { 
  ExportVirtualBatteriesResponse
} from "../types/virtualBattery";

export enum EndpointName {
  ExportContract = '/contracts/virtual_batteries/:batteries',
}

const exportVirtualBatteries = (batteries: string) => {
  return API.get<ExportVirtualBatteriesResponse>({
    endpoint: EndpointName.ExportContract,
    versions: [1],
    params: {
      batteries
    },
    config: {responseType: "blob"}
  });
}

export default exportVirtualBatteries;